import React, { Component } from "react"
import "react-dates/initialize"
import { SingleDatePicker, isInclusivelyBeforeDay } from "react-dates"
import "react-dates/initialize"
import "react-dates/lib/css/_datepicker.css"
import moment from "moment"

class DateField extends Component {
	constructor(props) {
		super(props)

		this.state = {
			focused: false,
			value: null,
			placeholder: "",
		}
	}

	handleChange = (value) => {
		if (!value || typeof value !== "object") {
			return
		}
		var timestamp = value.unix()
		if (this.props.row) {
			// THis is a traffic row
			this.props.onChange(`rows[${this.props.rowIndex}][${this.props.name}]`, value.unix())
		} else {
			// set timeout in place because react-dates initially loses focus for it's picker, then when you click on a date it handle's change, then it focuses again which sends three events to formik and the last event has a validation error.
			setTimeout(() => {
				this.props.onChange(this.props.name, timestamp)
			}, 10)
		}
	}

	handleBlur = () => {
		this.props.onBlur(this.props.name, true)
	}

	_focusChange = (focused) => {
		if (!focused.focused) {
			this.props.onBlur(this.props.name, true)
		}
		this.setState({
			focused: focused.focused,
		})
	}

	clear = () => {
		if (this.props.row) {
			// THis is a traffic row
			this.props.onChange(`rows[${this.props.rowIndex}][${this.props.name}]`, null)
		} else {
			// set timeout in place because react-dates initially loses focus for it's picker, then when you click on a date it handle's change, then it focuses again which sends three events to formik and the last event has a validation error.
			setTimeout(() => {
				this.props.onChange(this.props.name, null)
			}, 10)
		}
	}

	renderMonthElement = ({ month, onMonthSelect, onYearSelect }) => {
		let opts = []
		let currentYear = moment().year() + 4
		let numYears = this.props.birthday ? 100 : 25
		for (let i = currentYear - numYears; i <= currentYear; i++) {
			opts.push(
				<option value={i} key={i}>
					{i}
				</option>
			)
		}
		return (
			<div style={{ display: "flex", justifyContent: "center" }}>
				<div>
					<select value={month.month()} onChange={(e) => onMonthSelect(month, e.target.value)}>
						{moment.months().map((label, value) => (
							<option value={value} key={value}>
								{label}
							</option>
						))}
					</select>
				</div>
				<div>
					<select value={month.year()} onChange={(e) => onYearSelect(month, e.target.value)}>
						{opts}
					</select>
				</div>
			</div>
		)
	}

	render() {
		if (this.props.value) {
			var date = moment.unix(this.props.value)
			var placeholder = moment.unix(this.props.value).format("MM/DD/YYYY")
		} else {
			var date = null
		}
		return (
			<>
				<SingleDatePicker
					id={this.props.id ? this.props.id : this.props.name}
					onDateChange={this.handleChange}
					onFocusChange={this._focusChange}
					focused={this.state.focused}
					placeholder={this.props.placeholder}
					renderMonthElement={this.renderMonthElement}
					numberOfMonths={1}
					date={date}
					readOnly
					//showClearDate={true}
					isOutsideRange={(day) => {
						if (this.props.blockFuture) {
							return !isInclusivelyBeforeDay(day, moment())
						} else if (this.props.blockPast) {
							return isInclusivelyBeforeDay(day, moment())
						} else if (this.props.startDate) {
							//? Doesn't allow peopel to choose complete dates less than 60 days after the start date
							return isInclusivelyBeforeDay(day, moment.unix(this.props.startDate).add(60, "days"))
						} else if (this.props.outXDays) {
							//? Doesn't allow peopel to choose dates less than X days after today
							return isInclusivelyBeforeDay(day, moment().add(this.props.outXDays, "days"))
						} else {
							return false
						}
					}}
				/>
				<div className="datepicker__close" onClick={() => this.clear()}>
					X
				</div>
			</>
		)
	}
}

export default DateField
